import React from "react";
import styles from "./QuestCard.module.css";
// import { Quest } from '../../types';
import { getTicketWord } from "../../../../Services/utils";
import dreamcoinLogo from "/dreamcoin-logo.svg";
import ticketLogo from "/spin.svg";
import characterLogo from "/character-icon.svg";
import taskIcon from "/TaskIcon.svg";
import { QuestGroup } from "../../types";
import dreamcoinCharacter from "/expert-quest.png";
import computerQuest from "/advanced-quest.png";
import rocketImage from "/sapceship.webp";
import dreamer from "/dreamer.png";

interface QuestCardProps {
  quest: QuestGroup;
  onClick: (questId: number) => void;
}

export const QuestCard: React.FC<QuestCardProps> = ({ quest, onClick }) => {
  // Проверяем, что rewards существует и является массивом
  const rewards = Array.isArray(quest.rewards) ? quest.rewards : [];

  // Находим награды разных типов
  const dcReward = rewards.find((reward) => reward.type === "DC")?.amount || 0;
  const ticketsReward =
    rewards.find((reward) => reward.type === "tickets")?.amount || 0;
  const characterReward =
    rewards.find((reward) => reward.type === "character")?.amount || 0;

  // Получаем правильное склонение слова "билет"
  const ticketWord = getTicketWord(ticketsReward.toString());

  const handleClick = () => {
    onClick(quest.id);
  };

  const isLocked = quest.status !== "claimed" && quest.is_active === false;

  return (
    <div
      className={styles.questCard + (isLocked ? " " + styles.locked : "")}
      onClick={handleClick}
    >
      <div className={styles.questContainer}>
        <div className={styles.questContent}>
          <div className={styles.progressText}>
            <img src={taskIcon} alt="Task" />
            {quest.completed_tasks || 0}/{quest.total_tasks || 0}
          </div>

          <h4 className={styles.questTitle}>{quest.name}</h4>
          <div className={styles.rewards}>
            {dcReward > 0 && (
              <div className={styles.dcReward}>
                {dcReward} DC <img src={dreamcoinLogo} alt="DC" />
              </div>
            )}

            {ticketsReward > 0 && (
              <div className={styles.ticketReward}>
                {ticketsReward} {ticketWord}
                <img src={ticketLogo} alt="Tickets" />
              </div>
            )}

            {characterReward > 0 && (
              <div className={styles.characterReward}>
                {characterReward}
                <img src={characterLogo} alt="Character" />
              </div>
            )}
          </div>
          <picture className={styles.rocketImageContainer + quest.type}>
            <img
              src={
                quest.type === "expert-quest"
                  ? dreamcoinCharacter
                  : quest.type === "advanced-quest"
                  ? computerQuest
                  : quest.type === "mega-quest"
                  ? dreamer
                  : rocketImage
              }
              alt="Rocket"
              className={
                quest.type === "expert-quest"
                  ? styles.dreamcoinCharacter
                  : quest.type === "advanced-quest"
                  ? styles.computerQuest
                  : quest.type === "mega-quest"
                  ? styles.dreamer
                  : styles.rocketImage
              }
              loading="eager"
            />
          </picture>
        </div>
      </div>
    </div>
  );
};
